module.exports = __webpack_public_path__ + "img/mobile-apple-logo.7d92aa01.svg";